<template>
  <div class="container">
    <h1 class="mb-4">{{ withdraw.investor_name }}</h1>

    <div class="details">
      <div class="details__head">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item tabs-item">
            <a class="nav-link active" data-toggle="tab" role="tab" href="#details"><fai icon="info"/>
              &nbsp;Generales
            </a>
          </li>
        </ul>
      </div>
      <div class="details__body mt-4">
        <div class="tab-content">
          <!--begin: Details -->
          <div id="details" class="tab-pane fade show active" role="tabpanel" v-if="withdraw.id">
            <div class="row">
              <div class="col-sm-6">
                <h4 class="m--font-info">Datos Generales</h4>
              </div>
              <div class="col-sm-6 text-right" v-if="!withdraw.date_confirm">
                <button class="btn btn-success" @click="confirmWithdraw">
                  <fai :icon="['far','check-square']"/> Confirmar
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Acreedor</h5>
                  <span>{{ withdraw.investor_name }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Folio Contrato</h5>
                  <span>{{ withdraw.contract_folio }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Monto de retiro</h5>
                  <span>{{ withdraw.amount | formatCurrency }}</span>
              </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-4">
                    <h5>Estatus</h5>
                    <span>{{ withdraw.status }}</span>
                </div>
                <div class="col-sm-4">
                    <h5>Fecha de retiro</h5>
                    <span>{{ withdraw.date_retirement | formatDate }}</span>
                </div>
                <div class="col-sm-4">
                    <h5>Fecha de confirmación retiro</h5>
                    <span>{{ withdraw.date_confirm | formatDate }}</span>
                </div>
            </div>
            <hr class="mt-4"/>
            <!--begin: File -->
            <div class="row">
                <div class="col-sm col-md col-lg">
                    <h4 class="m--font-info">Comprobante de retiro</h4>
                </div>
            </div>
            <!--end: File -->
            <hr class="mt-4"/>
            <!--begin: Attachments -->
              <div class="row">
                <div class="col">
                  <h4>Anexos Afectados</h4>
                </div>
              </div>
              <div class="mt-2" v-if="attachments">
                <div class="row" v-if="attachments.cancelled">
                  <div class="col">
                    <h4 class="subtitle">Anexos Expirados</h4>
                  </div>
                </div>
                <div class="row" v-if="attachments.cancelled">
                  <div class="col">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Monto de inversión</th>
                          <th scope="col">Fecha de inicio</th>
                          <th scope="col">Fecha de vencimiento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="attachment in attachments.cancelled" :key="attachment.id">
                          <th scope="row" class="text-danger">{{ attachment.attachment_id }}</th>
                          <td>{{ attachment.amount | formatCurrency }}</td>
                          <td>{{ attachment.date_init | formatDate }}</td>
                          <td>{{ withdraw.date_retirement | formatDate }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row" v-if="attachments.new">
                  <div class="col">
                    <h4 class="subtitle">Anexos Renovados</h4>
                  </div>
                </div>
                <div class="row" v-if="attachments.new">
                  <div class="col">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Monto de inversión</th>
                          <th scope="col">Fecha de inicio</th>
                          <th scope="col">Fecha de vencimiento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="attachment in attachments.new" :key="attachment.id">
                          <th scope="row" class="text-success">{{ attachment.attachment_id }}</th>
                          <td>{{ attachment.amount | formatCurrency }}</td>
                          <td>{{ withdraw.date_retirement | formatDate }}</td>
                          <td>{{ attachment.date_expire | formatDate }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row" v-else>
                <div class="col">
                  <p class="text-danger" v-if="error">
                    {{ error }}
                  </p>
                  <h4 class="subtitle" v-else> - </h4>
                </div>
              </div>
            <!--end: Attachments -->
            <hr class="mt-4"/>
            <div class="row">
              <div class="col-sm col-md col-lg">
                <h4 class="m--font-info">Registro</h4>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-4">
                  <h5>Registrado por</h5>
                  <span>{{ withdraw.creator }}</span>
              </div>
              <div class="col-sm-4">
                  <h5>Fecha de registro en el sistema</h5>
                  <span>{{ withdraw.created_at | formatDate }}</span>
              </div>
            </div>
          </div>
          <!--end: Details -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import withdrawService from '@/services/withdraws'
import SysTable from '@/components/shared/Table'

export default {
  name: 'WithdrawDetail',

  components: { SysTable },

  data () {
    return {
      loaded: false,
      withdraw_details: {
        promoter_id: {
          name: 'Comprobante de retiro form',
          value: '',
          type: 'file',
          size: 12
        }
      },
      withdraw: {},
      attachments: null,
      error: null
    }
  },
  created: function () {
    this.loaded = false
    const id = this.$route.params.id
    let element = this.$store.getters.getSelectedElement

    if (element.type === 'withdraw' && element.data.id === id) this.withdraw = element.data
    else {
      withdrawService.getById(id).then(res => {
        this.withdraw = res.data

        withdrawService.getAttachments(id).then(res => {
          this.attachments = res
        })
      })
      this.loaded = true
    }
  },
  methods: {
    confirmWithdraw () {
      withdrawService.complete(this.$route.params.id).then(res => {
        this.$router.go(this.$router.currentRoute)
      }).catch(err => {
        console.log(JSON.stringify(err.data))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .subtitle {
    font-size: 1.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/withdraws/WithdrawDetail.vue